import { useEffect, useState } from 'react';
import client from '../api/client';
import { getCode } from '../api/lionjob';

// Cào bảng bán chạy của store đối thủ NGAY TRÊN SERVER — không cần ai mở trình duyệt.
// Vì sao có màn này: trước đây Trending của Lionjob đọc lại kho của matrixty, tức là ăn ké.
// Đây là nguồn riêng.
const hdr = (ms = 20000) => ({ headers: { 'x-lionjob-code': getCode() }, timeout: ms });
const api = {
  list: () => client.get('/lionjob/crawl/sources', hdr()).then((r) => r.data.data),
  discover: (domain) => client.post('/lionjob/crawl/sources/discover', { domain }, hdr(60000)).then((r) => r.data.data),
  save: (b) => client.post('/lionjob/crawl/sources', b, hdr()).then((r) => r.data),
  run: (id) => client.post('/lionjob/crawl/sources/run', id ? { id } : {}, hdr(600000)).then((r) => r.data),
  toggle: (id) => client.post(`/lionjob/crawl/sources/${id}/toggle`, {}, hdr()).then((r) => r.data),
  del: (id) => client.delete(`/lionjob/crawl/sources/${id}`, hdr()).then((r) => r.data),
};
const BOARD_VI = { 'best-seller': 'bán chạy', trending: 'xu hướng', hot: 'hot', 'popular-now': 'được chuộng', new: 'hàng mới' };

export default function StoreCrawlPanel({ onDone }) {
  const [rows, setRows] = useState([]);
  const [domain, setDomain] = useState('');
  const [found, setFound] = useState(null);     // kết quả dò, chờ người chọn bảng
  const [picked, setPicked] = useState(new Set());
  const [busy, setBusy] = useState('');
  const [msg, setMsg] = useState('');
  const [open, setOpen] = useState(false);

  const load = () => api.list().then((d) => setRows(d.rows || [])).catch(() => {});
  useEffect(() => { if (getCode()) load(); }, []);

  async function doDiscover() {
    const d = domain.trim(); if (!d) { setMsg('Nhập tên miền shop, ví dụ macorner.co'); return; }
    setBusy('discover'); setMsg('Đang dò bảng bán chạy của ' + d + '…'); setFound(null);
    try {
      const r = await api.discover(d);
      setFound(r);
      // Bảng nhỏ (chủ shop chọn tay) thì tick sẵn; bảng to để người dùng tự quyết.
      setPicked(new Set(r.boards.filter((b) => (b.productsCount ?? 0) <= 300).map((b) => b.handle)));
      setMsg(`Tìm thấy ${r.boards.length} bảng — tick cái muốn theo dõi rồi bấm Lưu.`);
    } catch (e) { setMsg('✗ ' + (e.response?.data?.message || e.message)); }
    finally { setBusy(''); }
  }

  async function doSave() {
    const boards = (found?.boards || []).filter((b) => picked.has(b.handle));
    if (!boards.length) { setMsg('Chưa tick bảng nào'); return; }
    setBusy('save');
    try {
      const r = await api.save({ domain: found.domain, boards });
      setMsg('✓ ' + r.message); setFound(null); setDomain(''); await load();
    } catch (e) { setMsg('✗ ' + (e.response?.data?.message || e.message)); }
    finally { setBusy(''); }
  }

  async function doRun(id) {
    setBusy('run' + (id || '')); setMsg('Đang cào… shop nhiều bảng có thể mất vài phút.');
    try {
      const r = await api.run(id);
      setMsg((r.data?.errors ? '⚠ ' : '✓ ') + r.message);
      await load(); onDone && onDone();
    } catch (e) { setMsg('✗ ' + (e.response?.data?.message || e.message)); }
    finally { setBusy(''); }
  }

  async function doToggle(id) { try { const r = await api.toggle(id); setMsg(r.message); await load(); } catch (e) { setMsg('✗ ' + e.message); } }
  async function doDel(id, d) {
    if (!window.confirm(`Bỏ theo dõi ${d}? (dữ liệu đã cào vẫn giữ nguyên)`)) return;
    try { const r = await api.del(id); setMsg(r.message); await load(); } catch (e) { setMsg('✗ ' + e.message); }
  }

  const active = rows.filter((r) => r.active).length;

  return (
    <div className="sc-wrap"><style>{CSS}</style>
      <div className="sc-bar">
        <button className="sc-toggle" onClick={() => setOpen((v) => !v)}>
          {open ? '▾' : '▸'} 🕷 Nguồn tự cào <span className="sc-n">{rows.length ? `${active}/${rows.length} shop` : 'chưa có'}</span>
        </button>
        <span className="sc-hint">Cào thẳng từ server, không cần mở trình duyệt</span>
        <div className="sc-sp" />
        {rows.length > 0 && (
          <button className="sc-btn primary" onClick={() => doRun()} disabled={!!busy}>
            {busy === 'run' ? '⏳ Đang cào…' : '⟳ Cào tất cả ngay'}</button>
        )}
      </div>
      {msg && <div className="sc-msg">{msg}</div>}

      {open && (
        <div className="sc-body">
          <div className="sc-add">
            <input className="sc-in" placeholder="macorner.co" value={domain} disabled={!!busy}
              onChange={(e) => setDomain(e.target.value)} onKeyDown={(e) => { if (e.key === 'Enter') doDiscover(); }} />
            <button className="sc-btn" onClick={doDiscover} disabled={!!busy}>
              {busy === 'discover' ? '⏳ Đang dò…' : 'Dò bảng bán chạy'}</button>
          </div>
          <div className="sc-note">
            Chỉ chạy với shop <b>Shopify</b> còn mở <code>collections.json</code>. Bảng quá to
            (&gt;2.000 SP) bị bỏ — đó là cả kho gắn nhãn "best sellers", thứ hạng ở đấy là nhiễu.
          </div>

          {found && (
            <div className="sc-found">
              <div className="sc-foundHead"><b>{found.domain}</b> — tick bảng muốn theo dõi</div>
              {found.boards.map((b) => (
                <label key={b.handle} className="sc-brow">
                  <input type="checkbox" checked={picked.has(b.handle)} onChange={(e) => {
                    const s = new Set(picked); e.target.checked ? s.add(b.handle) : s.delete(b.handle); setPicked(s);
                  }} />
                  <span className={'sc-board ' + b.board}>{BOARD_VI[b.board] || b.board}</span>
                  <span className="sc-bh">{b.handle}</span>
                  <span className="sc-bc">{b.productsCount ?? '?'} SP</span>
                </label>
              ))}
              <button className="sc-btn primary" onClick={doSave} disabled={!!busy} style={{ marginTop: 8 }}>
                {busy === 'save' ? '⏳…' : `Lưu ${picked.size} bảng`}</button>
            </div>
          )}

          {rows.map((r) => (
            <div key={r.id} className={'sc-src' + (r.active ? '' : ' off')}>
              <div className="sc-srcTop">
                <b>{r.domain}</b>
                <span className="sc-bc">{r.boards.length} bảng</span>
                {r.lastRunAt && <span className="sc-bc">lần cuối {new Date(r.lastRunAt).toLocaleString('vi', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' })} · {r.lastCount} SP</span>}
                <div className="sc-sp" />
                <button className="sc-btn sm" onClick={() => doRun(r.id)} disabled={!!busy}>
                  {busy === 'run' + r.id ? '⏳' : '⟳ Cào'}</button>
                <button className="sc-btn sm" onClick={() => doToggle(r.id)}>{r.active ? 'Tắt' : 'Bật'}</button>
                <button className="sc-btn sm danger" onClick={() => doDel(r.id, r.domain)}>Xoá</button>
              </div>
              <div className="sc-boards">
                {r.boards.map((b) => (
                  <span key={b.handle} className={'sc-board ' + b.board} title={`${b.handle} · ${b.productsCount ?? '?'} SP`}>
                    {BOARD_VI[b.board] || b.board}</span>
                ))}
              </div>
              {r.lastError && <div className="sc-err">⚠ {r.lastError}</div>}
            </div>
          ))}

          {rows.length === 0 && !found && (
            <div className="sc-empty">Chưa theo dõi shop nào. Nhập tên miền ở trên rồi bấm <b>Dò bảng bán chạy</b>.</div>
          )}
        </div>
      )}
    </div>
  );
}

const CSS = `
.sc-wrap{border:1px solid var(--border);border-radius:12px;background:var(--panel);margin-bottom:14px;overflow:hidden}
.sc-bar{display:flex;align-items:center;gap:10px;padding:9px 13px;flex-wrap:wrap}
.sc-toggle{background:none;border:0;color:var(--text);font-size:13px;font-weight:700;cursor:pointer;padding:0}
.sc-n{font-weight:500;color:var(--muted);margin-left:5px;font-size:12px}
.sc-hint{color:var(--muted);font-size:11.5px}
.sc-sp{flex:1}
.sc-msg{padding:0 13px 9px;font-size:12px;color:var(--muted)}
.sc-body{border-top:1px solid var(--border);padding:12px 13px}
.sc-add{display:flex;gap:8px}
.sc-in{flex:1;background:var(--input);color:var(--text);border:1px solid var(--border);border-radius:9px;padding:7px 11px;font-size:13px;min-width:0}
.sc-note{color:var(--muted);font-size:11.5px;margin-top:7px;line-height:1.55}
.sc-note code{background:var(--input);padding:0 4px;border-radius:4px}
.sc-btn{background:var(--panel);color:var(--text);border:1px solid var(--border);padding:7px 13px;border-radius:9px;cursor:pointer;font-size:12.5px;font-weight:600}
.sc-btn:hover:not(:disabled){border-color:var(--accent)}
.sc-btn:disabled{opacity:.5;cursor:not-allowed}
.sc-btn.primary{background:var(--accent);border-color:var(--accent);color:#fff}
.sc-btn.sm{padding:3px 9px;font-size:11.5px;font-weight:500}
.sc-btn.sm.danger:hover{border-color:#e5484d;color:#e5484d}
.sc-found{border:1px solid var(--accent);border-radius:10px;padding:10px 12px;margin-top:10px}
.sc-foundHead{font-size:12.5px;margin-bottom:7px}
.sc-brow{display:flex;align-items:center;gap:8px;padding:3px 0;font-size:12px;cursor:pointer}
.sc-bh{font-family:var(--font-mono);font-size:11px;color:var(--muted);overflow:hidden;text-overflow:ellipsis;white-space:nowrap;flex:1}
.sc-bc{color:var(--muted);font-size:11px;white-space:nowrap}
.sc-board{font-size:10.5px;font-weight:700;padding:1px 7px;border-radius:999px;background:rgba(127,127,127,.14);color:var(--muted);white-space:nowrap}
.sc-board.best-seller{background:rgba(62,207,142,.16);color:#3ecf8e}
.sc-board.trending{background:rgba(99,102,241,.16);color:#818cf8}
.sc-board.hot{background:rgba(229,72,77,.15);color:#e5484d}
.sc-board.popular-now{background:rgba(240,167,66,.15);color:#f0a742}
.sc-board.new{background:rgba(129,140,248,.14);color:#a5b4fc}
.sc-src{border:1px solid var(--border);border-radius:10px;padding:9px 11px;margin-top:9px}
.sc-src.off{opacity:.5}
.sc-srcTop{display:flex;align-items:center;gap:8px;flex-wrap:wrap;font-size:12.5px}
.sc-boards{display:flex;gap:5px;flex-wrap:wrap;margin-top:6px}
.sc-err{color:#e5484d;font-size:11.5px;margin-top:6px}
.sc-empty{color:var(--muted);font-size:12.5px;padding:14px 0;text-align:center}
`;
